import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "approved-circle",
  "use": "approved-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"approved-circle\">\n<circle cx=\"12\" cy=\"12\" r=\"7.5\" stroke=\"#2E8540\" />\n<path d=\"M8.3999 11.921L11.2215 14.3996L15.5999 9.59961\" stroke=\"#2E8540\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol